export default __webpack_public_path__ + "static/media/aboutImg02.21ee47c9.jpg";